// @ts-nocheck
import { postValveConfigure } from "@store/Framework/Services/ValveConfiguratorService";
import { ConfigureRequestModel, ConfigureResponseModel } from "@store/Framework/Types/ValveConfiguratorApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface SubmitValveConfigureResult {
    apiResult?: ConfigureResponseModel;
}

type HandlerType = Handler<ConfigureRequestModel, SubmitValveConfigureResult>;

export const DispatchBeginSubmit: HandlerType = props => {
    props.dispatch({ type: "Data/ValveConfigurator/BeginSubmitConfigure" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await postValveConfigure(props.parameter);
    } catch (error) {
        const message = error instanceof Error ? error.message : "Configuration request failed.";
        props.dispatch({ type: "Data/ValveConfigurator/FailSubmitConfigure", message });
        return false;
    }
};

export const DispatchCompleteSubmit: HandlerType = ({ dispatch, apiResult }) => {
    if (!apiResult) {
        return;
    }

    dispatch({ type: "Data/ValveConfigurator/CompleteSubmitConfigure", result: apiResult });
};

export const chain = [DispatchBeginSubmit, RequestDataFromApi, DispatchCompleteSubmit];

const submitValveConfigure = createHandlerChainRunner(chain, "SubmitValveConfigure");
export default submitValveConfigure;
